/**
 * Created by chuongnv 2017/09/28.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import {ApiEvsService} from './ApiEvs.service';

@Injectable()
export class EvsStampService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
    this.setEndPoint('/stamps');
  }

  activeGuaranteeStamps(data: any) {
    return this.post('/qr_aps/guarantee/active_guarantee/stamps', data);
  }

  //chuongnv:
  listOrder(data?: any) {
    return this.get('/items_order', data);
  }

  listStampService() {
    return this.get('/stamp_services');
  }

  changeStampStatus(data: any, status: any) {
    // for activeRelease or sample
    return this.post('/stamps/status/' + status, data);
  }

  changeStampStatusWithSerial(data: any, status: any) {
    // for activeRelease or sample
    return this.post('/stamps/status/' + status + '?type=serial', data);
  }

  getLogsActiveRelease(data?: any) {
    return this.get('/logs/action_stamp', data);
  }

  getAllStore(data?: any) {
    return this.get('/g_store', data);
  }

  getStore(id: any) {
    return this.get('/g_store/' + id);
  }

  logGuarantee(data: any) {
    return this.post('/guarantee', data);
  }

  activeGuarantee(data: any) {
    return this.post('/qr_aps/guarantee/active_guarantee', data);
  }

  guaranteeStasitic(data) {
    return this.get('/guarantee/history/statistic', data);
  }

  getLogGuarantee(data?: any) {
    return this.get('/guarantee', data);
  }

  downloadExcelGuarantee(data?: any) {
    return this.getExcel('/guarantee/excel', data);
  }

  updateGuaranteeStatus(serial: any, status: any) {
    return this.post('/guarantee/' + serial + '/' + status);
  }

  updateGuaranteeStatusById(id: any, status: any, body: any = null) {
    return this.put('/guarantee/' + id + '/' + status, body);
  }

  getLogGuaranteeByPhone(phone: any, data?: any) {
    return this.get('/g_customers/' + phone, data);
  }

  getUserByPhone(phone: any) {
    return this.get('/g_customer-phone/' + phone);
  }

  getDetailtLogGuaranteeByPhone(phone: any, data?: any) {
    return this.get('/g_customers/' + phone + '/guarantee_logs', data);
  }

  getHistoryOfCare(phone: any, data?: any) {
    return this.get('/g_customers/' + phone + '/history_of_care', data);
  }

  updateCare(phone: any, data?: any) {
    if (!data.body.note) {
      return this.put(
        '/g_customers/' + phone + '/history_of_care/' + data.status
      );
    } else {
      return this.put(
        '/g_customers/' + phone + '/history_of_care/' + data.status,
        data.body
      );
    }
  }

  getLogGuaranteeById(id: any) {
    return this.get('/guarantee/' + id);
  }

  getLogGuaranteeBySerial(serial: any, data?: any) {
    return this.get(`/guarantee/logs/serial?serial=${serial}`, data);
  }

  getInfoStamp(serial: any) {
    return this.get(`/guarantee/search/serial?serial=${serial}`);
  }

  getListStampInBox(query: any) {
    return this.get('/qr_aps/guarantee/box/stamps', query);
  }

  findStampBySerial(serial: string) {
    return this.get('/stamps/find/serial/' + serial);
  }

  // nguyen_dx
  // get all list stamp
  getList(data?: {}) {
    return this.get('/stamps', data);
  }

  // info total stamp
  getInfoStamps() {
    return this.get('/stamps/statistic');
  }

  // update status of stamp with checked
  multiUpdateStatus(status: string, data: any) {
    return this.multiPost('/stamps/status/' + status, data);
  }

  // find detail stamp by _id
  findStampById(id: number) {
    return this.get('/stamps/find/' + id);
  }

  // get list log of stamp
  getLogs(data?: {}) {
    return this.get('/logs/scan', data);
  }

  // get list log by id
  getLogsById(data?: {}) {
    return this.get('/logs/scan', data);
  }

  getListOrder(data?: {}) {
    return this.get('/items_order', data);
  }

  createFieldGuarantee(data: any) {
    return this.post('/guarantee/field', data);
  }

  updateFieldGuarantee(data: any) {
    return this.put('/guarantee/field', data);
  }

  getFieldGuarantee(options?: any) {
    return this.get('/guarantee/field/list', options);
  }

  getFieldGuarantee2(code) {
    return this.get(`/g_customers/field/list-client/${code}`);
  }

  getFieldGuarantee3(code) {
    return this.get(`/guarantee/field/list-client/${code}`);
  }

  getListField() {
    return this.get('/guarantee/field/raw', {});
  }


  createFieldGuaranteeCustomes(data: any) {
    return this.post('/g_customers/field', data);
  }

  updateFieldGuaranteeCustomes(data: any) {
    return this.put('/g_customers/field', data);
  }

  getFieldGuaranteeCustomes(options?: any) {
    return this.get('/g_customers/field/list', options);
  }

  getFieldGuaranteeCustomes2(code) {
    return this.get(`/g_customers/field/list-client/${code}`);
  }

  getListFieldCustomes() {
    return this.get('/g_customers/field/raw', {});
  }


  findStaticStampById(id) {
    return this.get('/static-stamps/' + id);
  }

  // post new update-note guarantee log
  createNewUpdatedNoteGuarantee(logId: string, body: any = null) {
    return this.post('/guarantee/note-inprogress/' + logId, body);
  }

  // get list history updated log guarantee
  getListHistoryNoteInProgress(logId: string, opt: any = null) {
    return this.get('/guarantee/note-inprogress/' + logId, opt);
  }

  /** Tuanba: 20-3-2024 **/
  public getFileTemplete() {
    return this.getFile('/qr_aps/guarantee/activation_template_file');
  }

}



// WEBPACK FOOTER //
// /app/src/app/common/services/EvsStamp.service.ts